// extracted by mini-css-extract-plugin
export var box = "_5y-0";
export var check = "_5y-1";
export var checkboxButton = "_5y-6";
export var checkboxGroup = "_5y-5";
export var disabled = "_5y-7";
export var ghost = "_5y-9";
export var input = "_5y-2";
export var label = "_5y-4";
export var normal = "_5y-8";
export var uncheck = "_5y-3";